import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";

import Select from "react-select";

import { toast } from "react-toastify";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faPlay, faPause, faFastForward, faTrash } from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import { SetupText } from "components/Next/Models/Models";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import FirstVarIcon from "images/Next-Icons/drill-in-2.svg";
import MicroscopeIcon from "images/Next-Icons/microscope-light 1.svg";
import TelescopeIcon from "images/Next-Icons/mode-voting.svg";
import StatAssocIcon from "images/Next-Icons/stats.svg";
import PopularIcon from "images/Next-Icons/mode-voting.svg";
import TrainIcon from "images/Next-Icons/TrainIcon.svg";

import ReviewDeployIcon from "images/Next-Icons/ReviewDeployIcon.svg";
import IntegrateIcon from "images/Next-Icons/IntegrateIcon.svg";
import MonitorSettingsIcon from "images/Next-Icons/MonitorSettingsIcon.svg";

import MagnifierIcon from "images/Next-Icons/MagnifierIcon.svg";
import SecurityCheckIcon from "images/Next-Icons/SecurityCheckIcon.svg";
import ScalesIconWhiteBackground from "images/Next-Icons/ScalesIconWhiteBackground.svg";

import StethoscopeIcon from "images/Next-Icons/StethoscopeIcon.svg";
import LabVialIcon from "images/Next-Icons/LabVialIcon.svg";
import WaypointIcon from "images/Next-Icons/WaypointIcon.svg";
import BullseyeIcon from "images/Next-Icons/BullseyeIcon.svg";
import MiniFunnelIcon from "images/Next-Icons/MiniFunnelIcon.svg";
import NewMoneyIcon from "images/Next-Icons/NewMoneyIcon.svg";
import MoneyIconLight from "images/Next-Icons/money-bill-light 2.svg";
import FairnessScalesIcon from "images/Next-Icons/FairnessScalesIcon.svg";
import ReturnIcon from "images/Next-Icons/ReturnIcon.svg";
import GearsIcon from "images/Next-Icons/GearsIcon.svg";
import ChartIcon from "images/Next-Icons/ChartIcon.svg";
import SpreadsheetIcon from "images/Next-Icons/SpreadsheetIcon.svg";

import AibleIcon from "images/Next-Icons/AibleIcon.png";

import ScenarioSelectContainer from "containers/Project/ScenarioSelect";

import AssignTodoModalContainer from "containers/Market/Jobs/AssignTodoModal";

import { centerHex } from "containers/Next/NextReducer";

import styles from "./style.module.css";

import { readableSearch } from "containers/Next/Models/ModelsReducer";
import { DEFAULT_LABELS } from "containers/Setup/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class NextFooter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      scenarioName: "Default Scenario",
      isDeployingProject: false,
      ignoreSteps: {},
      searchTypeOption: "All"
    };
  }

  componentDidUpdate(prevProps) {
    const { activeTab, replayInfo, exploreTodoNodes } = this.props;

    if (prevProps?.activeTab !== "EXPLORE" && activeTab === "EXPLORE") {
      const visibleActions = replayInfo?.visibleActions;

      const totalNodeCount =
        (exploreTodoNodes ? exploreTodoNodes.length : 0) + (visibleActions ? visibleActions.length : 0);

      if (totalNodeCount >= 20) {
        this.setState({ searchTypeOption: "Additions" });
      }
    } else if (prevProps?.activeTab === "EXPLORE" && activeTab !== "EXPLORE") {
      this.setState({ searchTypeOption: "All" });
    }
  }

  handleSelect(action) {
    const { modelsUpdateSelectedHex } = this.props;
    modelsUpdateSelectedHex(action);
  }

  renderReplayOverlay() {
    const { resetHex } = this.props;

    return (
      <div className={styles.replayOverlay} onClick={() => resetHex()}>
        <a>{"You are viewing a replay. Click here to exit back to the end of the timeline."}</a>
      </div>
    );
  }

  renderReplayBar(vActions, user) {
    const {
      id,
      isReplay,
      hexMap,
      updateIsReplay,
      replayActions,
      resetHex,
      resetActions,
      hasBeforeReplayHexMap,
      modelsSavedHexMap,
      activeTab,
      deleteTodo,
      assignTodo,
      updateIsCommentModal,
      exploreTodoNodes,
      projectId,
      datasetId,
      runId,
      optimized,
      blueprints,
      modelTodos,
      updateSelectedHex,
      applySetupStep,
      searchTimeline,
      modelsSearchTimeline,
      selectedHexModels,
      updatePinnedHex,
      updateHover,
      removeNode,
      setupLabels,
      timePeriod,
      isContinuous,
      expectedCountContinuous,
      expectedValueContinuous,
      updateSuppressAutoAddReview
    } = this.props;

    const { visibleActions, replayIndex } = this.props.replayInfo;

    const { searchTypeOption } = this.state;

    let gChartCount = 0;
    Object.keys(hexMap).forEach((k) => {
      const nodes = hexMap[k];
      nodes
        .filter((n) => n.isAdded !== true && n.type !== "Muscle Chart")
        .forEach((n) => {
          gChartCount++;
        });
    });

    const aibleAction = {
      type: "AIBLE",
      title: "Aible has automatically applied 4 steps for you based on the blueprint you selected."
    };

    let allActions =
      visibleActions === undefined
        ? []
        : [aibleAction, ...visibleActions.filter((action) => action.isVisible !== false)];

    let firstConsultantActionIndex = undefined;

    allActions.forEach((a, i) => {
      if (a.isConsultantAction === true && firstConsultantActionIndex === undefined) {
        firstConsultantActionIndex = i - 2;
      }
    });

    if (modelTodos && activeTab === "MODELS") {
      Object.keys(modelTodos)
        .filter(
          (t) =>
            true ||
            Object.keys(modelsSavedHexMap).find((sKey) => modelsSavedHexMap[sKey]?.id === modelTodos[t]?.id) ===
              undefined
        )
        .filter((t) => modelTodos[t] !== undefined)
        .forEach((t) => {
          allActions.push({
            isNotComplete: true,
            aTypeReadable: modelTodos[t]?.text,
            mNode: modelTodos[t]
          });
        });
    }

    const oldActions = [...allActions];

    let retReplayIndex = replayIndex;

    const searchKeys = modelsSearchTimeline ? modelsSearchTimeline.map((s) => s.value) : [];

    if (activeTab === "MODELS" && searchKeys.length > 0) {
      allActions = [];
      let unrelatedCounter = 0;

      oldActions.forEach((action) => {
        const nodeId = action?.node?.id || action?.mNode?.id;
        if (searchKeys.indexOf(nodeId) !== -1) {
          if (unrelatedCounter > 0) {
            allActions.push({ isCollapsed: true, count: unrelatedCounter });
            unrelatedCounter = 0;
            retReplayIndex++;
          }
          allActions.push(action);
        } else {
          unrelatedCounter++;
          retReplayIndex--;
        }
      });

      if (unrelatedCounter > 0) {
        allActions.push({ isCollapsed: true, count: unrelatedCounter });
        unrelatedCounter = 0;
        retReplayIndex++;
      }
    }

    // Add all remaining todos
    if (activeTab === "EXPLORE") {
      exploreTodoNodes &&
        exploreTodoNodes.forEach((todoNode) => {
          oldActions.push({ node: { ...todoNode }, isTodo: true });
        });
    }

    if (activeTab === "EXPLORE") {
      allActions = searchTimeline?.value !== undefined ? [] : oldActions;

      allActions = allActions.filter((action, i) => {
        if (
          action.type === "AIBLE" ||
          searchTypeOption === "All" ||
          (searchTypeOption === "Views" &&
            (action.type === "UPDATE_SELECTED_CHART" || action.type === "UPDATE_SELECTED_HEX")) ||
          (searchTypeOption === "Additions" && action.type === "UPDATE_PINNED_HEX") ||
          (searchTypeOption === "To Dos" && action.isTodo)
        ) {
          return true;
        } else {
          if (action?.isTodo !== true) {
            retReplayIndex--;
          }
          return false;
        }
      });

      if (searchTimeline?.value !== undefined) {
        let parentNodeTitle = searchTimeline?.value;

        console.log("wtf oldActions parentNodeTitle", oldActions, parentNodeTitle);
        let unrelatedCounter = 0;
        oldActions.reverse().forEach((action) => {
          const node =
            action?.n ||
            action?.node ||
            action?.rNode ||
            action?.mNode ||
            action?.selectionDirection ||
            action?.hex?.chart ||
            {};

          const actionTitle = node?.chart?.title;

          if (
            actionTitle !== undefined &&
            (actionTitle.indexOf(parentNodeTitle) !== -1 || actionTitle.indexOf(searchTimeline?.column) !== -1) &&
            searchTimeline?.value
          ) {
            if (action?.type === "UPDATE_PINNED_HEX") {
              parentNodeTitle = node?.parent?.parent?.chart?.title;
            }

            if (unrelatedCounter > 0) {
              allActions.push({ isCollapsed: true, count: unrelatedCounter });
              unrelatedCounter = 0;
              retReplayIndex++;
            }
            allActions.push(action);
          } else {
            unrelatedCounter++;
            retReplayIndex--;
          }
        });

        if (unrelatedCounter > 0) {
          allActions.push({ isCollapsed: true, count: unrelatedCounter });
          unrelatedCounter = 0;
          retReplayIndex++;
        }

        allActions = allActions.reverse();
      }
    }

    // Hacky Add fake action chart not found must have been aible generated
    if (searchTimeline?.value !== undefined && allActions.length === 1) {
      allActions.unshift({
        aTypeReadable: "Aible Generated and Added Chart: ",
        type: "AIBLE",
        mNode: { chart: { title: searchTimeline?.value } }
      });

      retReplayIndex++;
    }

    const userReplayIndex =
      firstConsultantActionIndex !== undefined && user === "Aible User"
        ? Math.min(firstConsultantActionIndex, retReplayIndex)
        : retReplayIndex;

    const searchTypeOptions = [
      { value: "All", label: "All" },
      { value: "Additions", label: "Additions" },
      { value: "Views", label: "Views" },
      { value: "To Dos", label: "To Dos" }
    ];

    const allRetActions =
      allActions &&
      allActions.filter(
        (action, i) =>
          action.type === "AIBLE" ||
          searchTypeOption === "All" ||
          (searchTypeOption === "Views" &&
            (action.type === "UPDATE_SELECTED_CHART" || action.type === "UPDATE_SELECTED_HEX")) ||
          (searchTypeOption === "Additions" && action.type === "UPDATE_PINNED_HEX") ||
          (searchTypeOption === "To Dos" && action.isTodo)
      );

    return (
      <div className={styles.repHolder}>
        {activeTab === "EXPLORE" && (
          <div className={styles.searchType}>
            <Select
              options={searchTypeOptions}
              value={searchTypeOptions.find((v) => v.value === searchTypeOption) || searchTypeOptions[0]}
              onChange={(val) => this.setState({ searchTypeOption: val.value })}
              menuPlacement={"top"}
            />
          </div>
        )}
        {this.renderSearch(oldActions)}
        <div className={styles.barHolder}>
          {isReplay && this.renderReplayOverlay()}
          <div className={styles.replay}>
            {/* {user} */}
            <ButtonGroup>
              <Button onClick={isReplay ? () => updateIsReplay(false) : () => replayActions(user)}>
                <FontAwesomeIcon icon={isReplay ? faPause : faPlay} />
              </Button>
              <Button
                onClick={() => resetHex()}
                disabled={hasBeforeReplayHexMap !== true}
                type={isReplay ? "primary" : "default"}
              >
                <FontAwesomeIcon icon={faFastForward} />
              </Button>
            </ButtonGroup>
          </div>
          <div className={styles.replayBarHolder}>
            <div
              className={styles.replayBar}
              id="replayBar"
              style={{
                width:
                  retReplayIndex === -1
                    ? "20px"
                    : "calc(" + ((retReplayIndex + 1) / allActions.length) * 100 + "% + 15px)"
              }}
            />
            {user === "Aible User" && (
              <div
                className={styles.rBarEmpty}
                id="replayBarEmpty"
                style={{
                  left:
                    firstConsultantActionIndex === -1
                      ? "20px"
                      : "calc(" + ((firstConsultantActionIndex + 1) / allActions.length) * 100 + "% + 15px)",
                  width:
                    firstConsultantActionIndex === -1
                      ? "0px"
                      : "calc(" +
                        ((retReplayIndex - firstConsultantActionIndex + 1) / allActions.length) * 100 +
                        "% + 15px)"
                }}
              />
            )}
            {user === "Jane C." && (
              <div
                className={styles.rBarEmpty}
                id="replayBarEmpty"
                style={{
                  width:
                    firstConsultantActionIndex === -1
                      ? "20px"
                      : "calc(" + ((firstConsultantActionIndex + 1) / allActions.length) * 100 + "% + 15px)"
                }}
              />
            )}
            <div
              className={styles.replayDot}
              style={{
                left: "calc(" + ((userReplayIndex + 1) / allActions.length) * 100 + "% + 11px)"
              }}
            >
              <FontAwesomeIcon icon={faCircle} />
            </div>
            <div className={styles.replayBarEmpty} />
            {allRetActions.map((action, i) => {
              const node =
                action?.n ||
                action?.node ||
                action?.rNode ||
                action?.mNode ||
                action?.selectionDirection ||
                action?.hex?.chart ||
                {};

              let isLast = false;

              if (activeTab === "MODELS" && action?.type !== "AIBLE" && action?.isNotComplete !== true) {
                let previousNodeIndex = -1;
                let sIndex = allActions.length - 1;

                for (; sIndex >= 0; sIndex--) {
                  if (allActions[sIndex]?.node?.id === action?.node?.id) {
                    previousNodeIndex = sIndex;
                    break;
                  }
                }

                if (previousNodeIndex === i) {
                  isLast = true;
                }
              }

              const type = node.chart?.metadata?.type;

              const title = action.isTodo
                ? "To Do Action Item"
                : action?.title || node.chart?.title || node?.parent?.chart?.title;

              const aType = action?.type;

              const color = node?.isNotComplete
                ? "gray"
                : node?.leftSection
                  ? "transparent"
                  : node.chart?.color
                    ? node.chart?.color
                    : node?.leftSection
                      ? "#7e69d7"
                      : aType === "UPDATE_SELECTION_DIRECTION"
                        ? "#7e69d7"
                        : "grey";

              const actionAfterSetup = action?.afterSetup ?? {};

              const firstAfterSetup =
                Object.keys(actionAfterSetup).length == 0
                  ? undefined
                  : action?.afterSetup[Object.keys(actionAfterSetup)[0]];

              const blueprintId =
                action?.afterSetup && Object.keys(action?.afterSetup).length > 0
                  ? action?.afterSetup[Object.keys(action?.afterSetup)[0]]?.blueprintId
                  : undefined;

              const businessConstraint = firstAfterSetup?.businessConstraints?.[0] ?? {};

              let businessObjective = undefined;

              switch (businessConstraint.type) {
                case "cost":
                  businessObjective = actionAfterSetup?.advancedCostLabel ?? DEFAULT_LABELS.advancedCostLabel;
                  break;
                case "revenue":
                  businessObjective = actionAfterSetup?.advancedRevenueLabel ?? DEFAULT_LABELS.advancedRevenueLabel;
                  break;
                case "profit":
                  businessObjective = actionAfterSetup?.netImpactLabel ?? DEFAULT_LABELS.netImpactLabel;
                  break;
              }

              const blueprint = blueprints.find((b) => b?.id === Number(blueprintId));

              const aTypeReadable = action?.isTodo
                ? node?.chart?.title
                : node?.id === "FAIR_GUIDE"
                  ? "Fairness Goals"
                  : node?.id === "DEPLOY_REVIEW"
                    ? "Models have been Deployed"
                    : action?.isCollapsed
                      ? action?.count + " unrelated " + (action?.count > 1 ? "updates" : "update") + " skipped"
                      : action?.aTypeReadable
                        ? action?.aTypeReadable
                        : node?.leftSection === "BLUEPRINT"
                          ? "Added Blueprint: " +
                            (blueprint === undefined
                              ? this.props?.blueprintId === "new"
                                ? "New Blueprint"
                                : blueprintId
                              : blueprint?.name)
                          : node?.leftSection === "STRATEGY"
                            ? "Strategy: " + businessObjective
                            : node?.leftSection === "EXPECTED"
                              ? "Updated Expected Behavior"
                              : node?.leftSection === "SUBGROUP"
                                ? "What Subgroup Do You Want To Optimize For?"
                                : node?.leftSection === "BASELINE"
                                  ? "Updated Baseline Behavior"
                                  : aType === "AIBLE"
                                    ? "Aible"
                                    : aType === "UPDATE_SELECTED_HEX"
                                      ? "Viewed Chart: "
                                      : action?.type === "UPDATE_SELECTED_CHART"
                                        ? "Viewed Chart: "
                                        : aType === "RESET_ACTIONS"
                                          ? "Returned to Story"
                                          : aType === "UPDATE_PINNED_HEX"
                                            ? "Added Chart: "
                                            : aType === "REMOVE_NODE"
                                              ? "Removed Chart: "
                                              : aType === "UPDATE_SELECTION_DIRECTION"
                                                ? node?.type
                                                : aType === "ADD_PINNED"
                                                  ? node?.type
                                                  : aType === "ADD_TO_PINNED_HEX_LIST"
                                                    ? "Added to Report"
                                                    : aType === "MOVE_HEX"
                                                      ? "Moved Chart: "
                                                      : "";

              const isCustomIcon =
                node?.id === "OPTIMIZE_BLUEPRINT" ||
                node?.id === "OPTIMIZE_TRANSACTION" ||
                node?.id === "OPTIMIZE_COSTS" ||
                node?.id === "OPTIMIZE_STRATEGY";

              const icon =
                node?.id === "OPTIMIZE_BALANCER"
                  ? FairnessScalesIcon
                  : node?.id === "OPTIMIZE_BLUEPRINT"
                    ? WaypointIcon
                    : node?.id === "DEPLOY_REVIEW"
                      ? ReviewDeployIcon
                      : node?.id === "DEPLOY_INTEGRATION"
                        ? IntegrateIcon
                        : node?.id === "DEPLOY_MONITOR"
                          ? MonitorSettingsIcon
                          : node.id === "OPTIMIZE_STRATEGY"
                            ? BullseyeIcon
                            : node.id === "OPTIMIZE_TRANSACTION"
                              ? MiniFunnelIcon
                              : node.id === "OPTIMIZE_COSTS"
                                ? NewMoneyIcon
                                : node.id === "OPTIMIZE_COSTS_BASELINE"
                                  ? MoneyIconLight
                                  : node.id === "PREDICT_WHAT_IF"
                                    ? StethoscopeIcon
                                    : node.id === "DEPLOY_REVIEW"
                                      ? LabVialIcon
                                      : node.id === "FAIR_GUIDE"
                                        ? ScalesIconWhiteBackground
                                        : node.id === "FAIR_VALUE"
                                          ? SecurityCheckIcon
                                          : node.id === "BUDGET_SUBGROUP"
                                            ? MicroscopeIcon
                                            : node.id === "BUDGET_RETRAIN"
                                              ? ReturnIcon
                                              : node.id === "EVAL_MODEL_DRIVERS"
                                                ? GearsIcon
                                                : node.id === "REVIEW_MODEL_METRICS"
                                                  ? SpreadsheetIcon
                                                  : node.id === "REVIEW_MODEL_CHARTS"
                                                    ? ChartIcon
                                                    : node?.leftSection
                                                      ? TrainIcon
                                                      : aType === "AIBLE"
                                                        ? AibleIcon
                                                        : aType === "UPDATE_SELECTION_DIRECTION"
                                                          ? node?.type === "Statistical Association"
                                                            ? StatAssocIcon
                                                            : node?.type === "Blah"
                                                              ? TelescopeIcon
                                                              : FirstVarIcon
                                                          : type
                                                            ? type === "Descriptive"
                                                              ? FirstVarIcon
                                                              : type === "Correlation"
                                                                ? StatAssocIcon
                                                                : type === "ModelDrivers"
                                                                  ? TelescopeIcon
                                                                  : type === "Popular"
                                                                    ? PopularIcon
                                                                    : TelescopeIcon
                                                            : TelescopeIcon;

              const retProps = {
                id: projectId,
                runId: projectId === "new" ? "new" : runId,
                datasetId: datasetId,
                isNext: true,
                isModelsNext: true,
                hideModel: true
              };

              const bStyle = { padding: "4px" };

              const hasTooltipActions = activeTab === "MODELS" || activeTab === "EXPLORE";

              return (user === "Jane C." && action.isConsultantAction !== true) ||
                (user === "Aible User" && action.isConsultantAction === true) ? (
                <div key={i} />
              ) : (
                <OverlayTrigger
                  key={i}
                  placement="top"
                  trigger={hasTooltipActions ? ["click"] : ["hover"]}
                  rootClose
                  ref="overlay"
                  overlay={
                    <Popover id="popover-positioned-top">
                      <div className={styles.pFlex}>
                        {activeTab === "MODELS" && node?.parent?.text}
                        <div
                          className={styles.pAction}
                          style={
                            activeTab === "MODELS" && action?.type !== "AIBLE"
                              ? { marginTop: "10px", marginBottom: "10px" }
                              : {}
                          }
                        >
                          {aTypeReadable}
                          {node?.isRevert === true && <span className={styles.rBadge}>{"REVERTED"}</span>}
                          {isLast === true && <span className={styles.rBadgeCurrent}>{"CURRENT"}</span>}
                        </div>
                        <div className={styles.pValue}>{title}</div>
                        {node?.leftSection ? (
                          <SetupText
                            fSetup={action?.setupStep?.[runId]}
                            node={node}
                            optimized={optimized}
                            setupLabels={setupLabels}
                            timePeriod={timePeriod}
                            isContinuous={isContinuous}
                            expectedCountContinuous={expectedCountContinuous}
                            expectedValueContinuous={expectedValueContinuous}
                          />
                        ) : (
                          <div />
                        )}
                        {hasTooltipActions && action?.type !== "AIBLE" && action?.isCollapsed !== true && (
                          <div className={styles.buttonHolder}>
                            {activeTab === "MODELS" ? (
                              <ButtonGroup>
                                <Button
                                  onClick={() => {
                                    let retIgnoreSteps = {
                                      ...this.state.ignoreSteps
                                    };
                                    retIgnoreSteps[action?.mNode?.id] = true;
                                    this.setState({
                                      ignoreSteps: retIgnoreSteps
                                    });
                                    if (action?.mNode?.id === "EVAL_MODEL_DRIVERS") updateSuppressAutoAddReview(true);
                                    console.log("deleting todo");
                                    console.log(action);
                                    console.log("~~~~~~~~");
                                    deleteTodo(action);
                                    document.body.click();
                                  }}
                                  style={bStyle}
                                  disabled={action.isNotComplete !== true}
                                >
                                  {"Ignore"}
                                </Button>
                                <Button
                                  onClick={() =>
                                    this.handleSelect({
                                      ...action,
                                      showRevert: isLast !== true
                                    })
                                  }
                                  style={bStyle}
                                >
                                  {"View"}
                                </Button>
                                <Button
                                  style={bStyle}
                                  onClick={() =>
                                    updateIsCommentModal({
                                      aTypeReadable: aTypeReadable,
                                      node: node,
                                      nextId: id
                                    })
                                  }
                                >
                                  {"Comment"}
                                </Button>
                                <Button onClick={() => assignTodo(action)} style={bStyle}>
                                  {"Assign"}
                                </Button>
                                <Button
                                  onClick={() => applySetupStep(action)}
                                  disabled={action.isNotComplete === true || isLast === true}
                                  style={bStyle}
                                >
                                  {"Revert"}
                                </Button>
                              </ButtonGroup>
                            ) : (
                              <ButtonGroup>
                                <Button onClick={() => removeNode(node, node)} style={bStyle}>
                                  {"Delete"}
                                </Button>
                                <Button
                                  onClick={() => {
                                    resetActions();
                                    updateSelectedHex(node, node);
                                    centerHex(node);
                                  }}
                                  style={bStyle}
                                >
                                  {"View"}
                                </Button>
                                <Button
                                  style={bStyle}
                                  onClick={() =>
                                    updateIsCommentModal({
                                      aTypeReadable: node?.chart?.title,
                                      node: {
                                        ...node,
                                        id: node?.chart?.title,
                                        text: node?.chart?.title
                                      },
                                      nextId: id
                                    })
                                  }
                                >
                                  {"Comment"}
                                </Button>
                                <Button
                                  onClick={() =>
                                    assignTodo({
                                      node: {
                                        ...node,
                                        id: node?.chart?.title,
                                        text: node?.chart?.title
                                      },
                                      nextId: id
                                    })
                                  }
                                  style={bStyle}
                                >
                                  {"Assign"}
                                </Button>
                                <Button
                                  onClick={() => {
                                    updatePinnedHex(node, node);
                                    resetActions();
                                    document.body.click();
                                  }}
                                  style={bStyle}
                                  disabled={action?.isTodo !== true}
                                >
                                  {"Add To Report"}
                                </Button>
                              </ButtonGroup>
                            )}
                          </div>
                        )}
                        {action?.isConsultantAction && (
                          <div className={styles.pAction}>{"From Consultant: Jane C."}</div>
                        )}
                      </div>
                    </Popover>
                  }
                >
                  <div
                    className={styles.replayAction}
                    style={{
                      left: "calc(" + (i / allActions.length) * 100 + "% + 15px)"
                    }}
                    title={aTypeReadable}
                  >
                    <div className={styles.dotIcon} onClick={hasTooltipActions ? () => {} : () => replayAction(action)}>
                      <FontAwesomeIcon
                        icon={faCircle}
                        style={{
                          color: isLast
                            ? "#5BCF74"
                            : activeTab === "MODELS" &&
                                selectedHexModels?.id &&
                                selectedHexModels?.id === action?.mNode?.id
                              ? "#F47C20"
                              : retReplayIndex >= i
                                ? "white"
                                : "#7E69D7"
                        }}
                      />
                    </div>
                    {action?.isCollapsed === true ? (
                      <div className={styles.collapsedAction}>{action?.count}</div>
                    ) : (
                      <div
                        className={
                          isCustomIcon
                            ? activeTab === "MODELS"
                              ? styles.whiteIcon
                              : styles.nIcon
                            : aType === "AIBLE"
                              ? styles.aIcon
                              : activeTab === "MODELS"
                                ? styles.whiteIcon
                                : styles.repIcon
                        }
                        style={{
                          background: activeTab === "MODELS" ? "white" : color,
                          cursor: "pointer",
                          transform: "scale(" + Math.min(0.5, 15 / allRetActions.length) + ")"
                        }}
                        onMouseEnter={activeTab === "EXPLORE" ? () => updateHover(node) : () => {}}
                        onClick={
                          hasTooltipActions
                            ? () => {}
                            : action?.type === "AIBLE"
                              ? () => {}
                              : action?.isNotComplete || activeTab === "MODELS"
                                ? () => this.handleSelect(action)
                                : () => updateSelectedHex(node)
                        }
                      >
                        <img src={icon} style={{ background: color }} />
                      </div>
                    )}
                  </div>
                </OverlayTrigger>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  renderSaveModal() {
    const { saveScenario, projectId, saveNext, isOpenSaveModal, updateIsOpenSaveModal, updateIsSavingScenario } =
      this.props;
    const { scenarioName } = this.state;

    return (
      <div id={"todoModal"}>
        <Dialog open={isOpenSaveModal === true} onOpenChange={() => updateIsOpenSaveModal(false)}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Save Scenario</DialogTitle>
            </DialogHeader>
            <div>
              <div style={{ width: "500px" }}>
                <LineInput
                  label="Scenario Name"
                  isMediumBox
                  placeholder="Default Scenario"
                  onChange={(val) => this.setState({ scenarioName: val })}
                />
              </div>
            </div>
            <DialogFooter>
              <Button type="secondary" onClick={() => updateIsOpenSaveModal(false)} style={{ marginRight: "auto" }}>
                {"Close"}
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  updateIsSavingScenario(true);
                  const promises = [
                    saveScenario(projectId, scenarioName || "Default Scenario"),
                    saveNext("Scenario Saved", false)
                  ];
                  Promise.all(promises)
                    .then(() => {
                      updateIsSavingScenario(false);
                      toast(<div>{"Scenario Saved"}</div>, {
                        type: toast.TYPE.SUCCESS,
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 7500
                      });
                    })
                    .catch((e) => {
                      console.log(e);
                      updateIsSavingScenario(false);
                    });
                  updateIsOpenSaveModal(false);
                }}
              >
                {"Save"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  renderScenarioActions() {
    const { blueprintId, projectId, deleteScenario, selectedScenario, updateIsOpenSaveModal, isSavingScenario } =
      this.props;

    return (
      <div className={styles.scenarioRight} style={{ alignItems: "flex-end", paddingRight: "10px" }}>
        {blueprintId === undefined && (
          <div className={styles.scenarioActions}>
            <ButtonGroup>
              <Button disabled={isSavingScenario} onClick={() => updateIsOpenSaveModal(true)}>
                {isSavingScenario ? (
                  <LoadingIndicator
                    style={{
                      width: "20px",
                      height: "18px",
                      transform: "scale(0.30)",
                      margin: "-5px 5px 5px -5px"
                    }}
                  />
                ) : (
                  "Save Scenario"
                )}
              </Button>
              <Button onClick={() => deleteScenario(projectId)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </ButtonGroup>
          </div>
        )}
      </div>
    );
  }

  renderSearch(actions) {
    const { dataset, rankedFields, activeTab, updateSearchTimeline, searchTimeline, modelsSearchTimeline } = this.props;

    const retActions = actions.map((a) => ({
      ...a,
      searchText: a?.node?.id || a?.mNode?.id || a?.node?.chart?.title || a?.n?.chart?.title
    }));

    const searchOptions = retActions.filter((a) => a.type !== "AIBLE" && a?.searchText).map((a) => a?.searchText);

    const uSearchOptions = [...new Set(searchOptions)].map((o) => ({
      label: readableSearch[o] || o,
      value: o
    }));

    const outcome = dataset?.fields?.[dataset?.outcome];

    const exploreOptions = dataset?.fields
      ? Object.keys(dataset?.fields).map((field) => {
          const currProb = outcome?.inclusionProbabilities?.find((prob) =>
            prob?.keys?.every((k) => k === field)
          )?.value;
          const score = currProb !== undefined ? currProb : 0;
          return {
            labelScore: "(" + (Number.isInteger(score) ? score : score?.toFixed(2)) + ") " + field,
            label: field,
            value: field,
            column: field,
            color: rankedFields.find((r) => r.label === field)?.color,
            oScore: score,
            score: score + 5
          };
        })
      : [];

    if (dataset?.fields) {
      Object.keys(dataset?.fields).forEach((fKey) => {
        const field = dataset.fields[fKey];

        field.data &&
          field.data.forEach((data) => {
            const currProb = outcome?.inclusionProbabilities?.find((prob) =>
              prob?.keys?.every((k) => k === fKey)
            )?.value;
            const score = currProb !== undefined ? currProb : 0;
            exploreOptions.push({
              value: data.value,
              labelScore: "(" + (Number.isInteger(score) ? score : score?.toFixed(2)) + ") " + fKey + ": " + data.value,
              label: fKey + ": " + data.value,
              column: fKey,
              color: rankedFields.find((r) => r.label === fKey)?.color,
              oScore: score,
              score: score
            });
          });
      });
    }

    return (
      <div className={styles.search}>
        <Select
          components={{ Option: CustomOption }}
          isClearable
          isMulti={activeTab === "MODELS"}
          options={activeTab === "MODELS" ? uSearchOptions : exploreOptions.sort((a, b) => b.score - a.score)}
          menuPlacement="top"
          placeholder="Search Timeline..."
          onChange={(val) => updateSearchTimeline(val)}
          value={activeTab === "MODELS" ? modelsSearchTimeline : searchTimeline}
        />
      </div>
    );
  }

  render() {
    const { id, blueprintId, activeTab, hexMap, projectId } = this.props;

    const { visibleActions } = this.props.replayInfo;

    let gChartCount = 0;
    Object.keys(hexMap).forEach((k) => {
      const nodes = hexMap[k];
      nodes
        .filter((n) => n.isAdded !== true && n.type !== "Muscle Chart")
        .forEach((n) => {
          gChartCount++;
        });
    });

    const aibleAction = {
      type: "AIBLE",
      title: "Aible has automatically applied 4 steps for you based on the blueprint you selected."
    };

    const vActions =
      visibleActions === undefined
        ? []
        : [
            aibleAction,
            ...visibleActions.filter((action) => action.isVisible !== false && action.isConsultantAction !== true)
          ];

    const consultantActions =
      visibleActions === undefined ? [] : [...visibleActions.filter((action) => action.isConsultantAction === true)];

    let allActions =
      visibleActions === undefined
        ? []
        : [aibleAction, ...visibleActions.filter((action) => action.isVisible !== false)];

    const hasConsultantAction =
      visibleActions === undefined ? undefined : visibleActions.find((a) => a.isConsultantAction === true);

    return (
      <div
        id="nextFooter"
        className={styles.footer}
        style={
          true
            ? { height: hasConsultantAction ? "120px" : "60px" }
            : { height: "0px", borderTop: "1px solid transparent" }
        }
      >
        {this.renderSaveModal()}
        {activeTab === "MODELS" && blueprintId === undefined && <ScenarioSelectContainer projectId={projectId} />}
        {activeTab === "MODELS" && this.renderScenarioActions()}
        {hasConsultantAction ? (
          <div className={styles.rHolder}>
            {this.renderReplayBar(consultantActions, "Jane C.")}
            {this.renderReplayBar(vActions, "Aible User")}
          </div>
        ) : (
          <div className={styles.rHolder}>{this.renderReplayBar(allActions, "Aible User")}</div>
        )}
        {(activeTab === "MODELS" || activeTab === "EXPLORE" || activeTab === "TRANSFORM") && (
          <AssignTodoModalContainer id={id} />
        )}
      </div>
    );
  }
}

const CustomOption = (option) => {
  return (
    <div className={styles.cOption} {...option?.innerProps}>
      {option?.data?.label}
      <div className={styles.cOptionOuterBar}>
        <div
          className={styles.cOptionInnerBar}
          style={{
            width: option?.data?.oScore * 100 + "%",
            background: option?.data?.color
          }}
        />
      </div>
    </div>
  );
};
